<template>
	<div v-show="show" @click="close()">
		<div class="emotion-box" :style="{ 'left': x + 'px', 'top': y + 'px' }">
			<el-scrollbar style="height: 220px">
				<div class="emotion-item-list">
					<div class="emotion-item" v-for="(emoText, i) in $emo.emoTextList" :key="i"
						@click="onClickEmo(emoText)" :ref="`emoItem_${i}`">
					</div>
				</div>
			</el-scrollbar>
		</div>
	</div>
</template>

<script>
import VSCodeAdapter from '../../api/vscode-adapter.js';

export default {
	name: "emotion",
	data() {
		return {
			show: false,
			pos: {
				x: 0,
				y: 0
			},
			adapter: null,
			rendered: false
		}
	},
	mounted() {
		// 初始化VSCode适配器（不需要new，直接使用对象）
		this.adapter = VSCodeAdapter;
	},
	updated() {
		// 每次更新后渲染emoji
		this.renderEmojis();
	},
	methods: {
		/**
		 * 安全渲染所有emoji
		 */
		renderEmojis() {
			if (!this.show || this.rendered) {
				return;
			}
			
			this.$nextTick(() => {
				this.$emo.emoTextList.forEach((emoText, i) => {
					const refName = `emoItem_${i}`;
					const element = this.$refs[refName];
					
					if (element && element[0]) {
						try {
							// 使用适配器安全设置emoji HTML
							const emoHtml = this.$emo.textToImg(emoText, 'emoji-large');
							this.adapter.setInnerHTML(element[0], emoHtml);
						} catch (error) {
							console.warn('[Emotion] Failed to render emoji with adapter:', error);
							// 降级处理：使用纯文本
							element[0].textContent = emoText;
						}
					}
				});
				this.rendered = true;
			});
		},
		onClickEmo(emoText) {
			let emotion = `#${emoText};`
			this.$emit('emotion', emotion)
		},
		open(pos) {
			this.pos = pos;
			this.show = true;
			this.rendered = false; // 重置渲染状态
			// 延迟渲染emoji
			this.$nextTick(() => {
				this.renderEmojis();
			});
		},
		close() {
			this.show = false;
			this.rendered = false;
		}
	},
	computed: {
		x() {
			return this.pos.x - 22;
		},
		y() {
			return this.pos.y - 234;
		}
	}
}
</script>
<style scoped lang="scss">
.emotion-box {
	position: fixed;
	width: 372px;
	box-sizing: border-box;
	padding: 5px;
	//border-radius: 5px;
	background-color: #fff;
	box-shadow: var(--im-box-shadow);

	.emotion-item-list {
		display: flex;
		flex-wrap: wrap;

		.emotion-item {
			text-align: center;
			cursor: pointer;
			padding: 2px;

		}
	}

	//&:after {
	//	content: "";
	//	position: absolute;
	//	left: 185px;
	//	bottom: -30px;
	//	width: 0;
	//	height: 0;
	//	border-style: solid dashed dashed;
	//	border-color: #f5f5f5 transparent transparent;
	//	overflow: hidden;
	//	border-width: 15px;
	//}
}
</style>
